import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
class ApprovalProcessService{
    static async getDropDownListData(category){
        try{
          
            const url = API_ENDPOINTS.getDropDownListAll(category);
            const token = localStorage.getItem('token');
            const response = await axiosInstance.get(url,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          const result = response.data;
          if(result.result.length > 0){
            
            return { success: true,data:result };
          }else {
            
            return { success: false, data: result };
          }
        }
        catch(error){
            console.error("Error Occured:",error)
        }
    }

    static async getMenuListData(userID){
      try{
        
          const url = API_ENDPOINTS.getMenuAll(userID);
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }
  static async getMarqueeMsg(){
      try{
          const url = API_ENDPOINTS.getMarqueeMsg();
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }
    
    static async CreateApproval(formData) {
        try {
            debugger
          const url = API_ENDPOINTS.InsertApprover();
          const token = localStorage.getItem('token');
          const response = await axiosInstance.post(url, formData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          debugger
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }
}
    
export default ApprovalProcessService